import { render } from "./MeterReadingsDetail.vue?vue&type=template&id=0146ff26"
import script from "./MeterReadingsDetail.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./MeterReadingsDetail.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script